import { render, staticRenderFns } from "./LocalEmojiPack.vue?vue&type=template&id=1f26166f&"
import script from "./LocalEmojiPack.vue?vue&type=script&lang=js&"
export * from "./LocalEmojiPack.vue?vue&type=script&lang=js&"
import style0 from "./LocalEmojiPack.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LocalEmojiPack.vue"
export default component.exports